const NotificationsPage = () => {
	return (
		<main>
			<h1>Notifications Page</h1>
		</main>
	);
};

export default NotificationsPage;
